export const GYRO_CONTRACT_ADDRESS = '0x96a8fc2d80f464bd734ce8ed31bd34a48176e5a7'
export const JSON_RPC_PROVIDER = 'https://bsc-dataseed1.binance.org:443'
